import { useState, useEffect, useRef, useCallback } from 'react';

import { cn } from '@lcsc-ui/lib/utils';

export default function ProductTabs({ items = [], productRecommendMounted, topPlaceholderRef, bottomPlaceholderRef }) {
  const [isClient, setIsClient] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [isFullWidth, setIsFullWidth] = useState(false);
  const [activeTab, setActiveTab] = useState(items[0]?.id);
  const [visibleItems, setVisibleItems] = useState([]);
  const tabsRef = useRef(null);

  const calculateSticky = useCallback(() => {
    if (!topPlaceholderRef?.current) return;
    const placeholderRect = topPlaceholderRef.current.getBoundingClientRect();
    setIsSticky(placeholderRect.top < 0);
  }, [topPlaceholderRef]);

  const calculateFullWidth = () => {
    if (!bottomPlaceholderRef?.current) return;
    const placeholderRect = bottomPlaceholderRef.current.getBoundingClientRect();
    setIsFullWidth(placeholderRect.top < 100);
  };

  // 通过滚动计算 isSticky
  useEffect(() => {
    const handleScroll = () => {
      calculateSticky();
      calculateFullWidth();
    };

    // 初始检查一次
    calculateSticky();
    calculateFullWidth();

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isClient, productRecommendMounted, calculateSticky]);

  // 初始化时检测哪些 section 存在
  useEffect(() => {
    const existingItems = items.filter((item) => {
      const section = document.getElementById(item.id);
      return section !== null;
    });

    setVisibleItems(existingItems);
    if (existingItems.length > 0) {
      setActiveTab(existingItems[0].id);
    }

    setIsClient(true);
  }, [items, productRecommendMounted]);

  // 滚动监听和高亮逻辑
  useEffect(() => {
    if (visibleItems.length === 0) return;
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 72;
      // 从下往上检查
      for (let i = visibleItems.length - 1; i >= 0; i--) {
        const section = document.getElementById(visibleItems[i].id);
        if (section) {
          const offsetTop = section.offsetTop;
          if (scrollPosition >= offsetTop) {
            setActiveTab(visibleItems[i].id);
            break;
          }
        }
      }
    };
    // 初始检查一次
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [visibleItems]);

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    const section = document.getElementById(tabId);
    if (section) {
      window.scrollTo({
        top: section.offsetTop - 70,
      });
    }
  };

  if (visibleItems.length === 0) {
    return null; // 如果没有可显示的 tab，则不渲染任何内容
  }

  return (
    <>
      <div
        ref={tabsRef}
        className={`${isSticky ? 'fixed top-[72px]' : 'absolute mt-[20px]'} ${isFullWidth ? 'w-[1200px]' : 'w-[810px]'} z-[50] px-[20px] h-[52px] bg-white rounded-t-[20px]`}
      >
        <ul className="rounded-t-[20px] pt-[20px] border-b border-solid border-[#cecfd487]">
          {visibleItems.map((item) => {
            return (
              <li
                key={item.id}
                className={cn(
                  'transition cursor-pointer text-[18px] font-bold leading-[24px] mr-[30px] h-[32px] inline-block text-[#3B3B3B] hover:text-[#0093E6]',
                  {
                    'text-[#0093E6] border-b-[3px] border-solid border-[#0093E6]': activeTab === item.id,
                  }
                )}
                onClick={() => handleTabClick(item.id)}
              >
                {item.name}
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
}
